import React from 'react';
const facts = [{
  value: '240+',
  label: 'Praktycznych stron gotowych do druku'
}, {
  value: '6 + 6',
  label: 'Tomów i darmowych bonusów w zestawie'
}, {
  value: '50',
  label: 'Gotowych ćwiczeń jazzowych'
}, {
  value: '10 dni',
  label: 'Gwarancji zwrotu pieniędzy — bez pytań'
}];
export function SocialProofBar() {
  return <section aria-label="Co zawiera pakiet" className="border-y border-night-600 bg-night-900" data-id="element-304" data-mp="25u5ephlxh9dm">
      <div className="mx-auto grid max-w-shell grid-cols-2 gap-y-7 px-5 py-8 sm:px-6 sm:py-10 lg:grid-cols-4 lg:gap-x-8" data-id="element-305" data-mp="32htkr18ptbgt">
        {facts.map((fact, index) => <div key={fact.value} className={`px-1 lg:px-6 ${index > 0 ? 'lg:border-l lg:border-night-600' : ''}`} data-id="element-306" data-mp="2thwzl9ljauqi" data-mpi={index}>
            <p className="font-display text-3xl leading-none text-amber sm:text-4xl" data-id="element-307" data-mp="2oj27ti5l9vu9">{fact.value}</p>
            <p className="mt-3 max-w-[15rem] text-xs leading-relaxed text-cream-muted" data-id="element-308" data-mp="1i4ktes2ay016">{fact.label}</p>
          </div>)}
      </div>
    </section>;
}